import { Button, Card, Col, Container, Row, Stack } from "react-bootstrap";
import Layout from "../../shared/components/Layout";
import Header from "../../shared/components/Header";
import CurrentPlanBlock from "../component/CurrentPlanBlock";
import InvoiceBlock from "../component/InvoiceBlock";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchCurrentPlanFeatures, resetError } from "../store/plansSlice";
import { useEffect } from "react";
import { fetchOrders } from "../store/ordersSlice";
import { toast, ToastContainer } from "react-toastify";
import { logout } from "../../auth/store/authSlice";

const BillIndex = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { currentTenant } = useSelector((state) => (state.sharedSlice));
  const { accessToken } = useSelector((state) => state.auth);
  const { currentPlanError, currentPlanErrorMessage } = useSelector((state) => state.plans);

  useEffect(() => {
    if (currentPlanError) {
      dispatch(resetError())
      if (currentPlanErrorMessage == "Token is invalid or expired") {
        toast.error("Your session has expired. Please login again.")
          dispatch(logout())
          navigate("/login")
      } else {
        toast.error("Unable to fetch plans. Please try again later.");
      }

    }
  }, [currentPlanError])


  useEffect(() => {
    dispatch(fetchCurrentPlanFeatures({
      access_token: accessToken,
      tenantId: currentTenant?.id,

    }));
    dispatch(
      fetchOrders({
        access_token: accessToken,
        tenantId: currentTenant?.id,
      })
    );

  }, [location])

  return (
    <Layout>
      <ToastContainer />
      <Header title={"Manage Billing"} ItemActions={
        <Stack>
          <Button
            variant="outline-secondary"
            onClick={() => {
              navigate("/business");
            }}
          >
            Back
          </Button>
        </Stack>
      } />
      <Container
        fluid
        className="px-4 py-3"
      >
        <Row className="gy-4">
          <Col lg={4} md={12}>
            <CurrentPlanBlock tenantId={currentTenant?.id} />
          </Col>
          <Col lg={8} md={12}>
            <Card className="border-0 shadow-sm h-100">
              <Card.Header className="bg-white border-0 d-flex justify-content-between align-items-center">
                <span className="fw-semibold">Invoices</span>
              </Card.Header>
              <Card.Body className="pt-0">
                <InvoiceBlock tenantId={currentTenant?.id} />
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </Layout>
  );
};

export default BillIndex;
